import { render, staticRenderFns } from "./DocumentRecordNew.vue?vue&type=template&id=7e75da01"
import script from "./DocumentRecordNew.vue?vue&type=script&lang=js"
export * from "./DocumentRecordNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports